import React from "react";
import Box from "@mui/material/Box";
import { RouterProvider } from "react-router";
import { ToastContainer } from "react-toastify";

import { router } from "./Routes/Router";

import '@fontsource/dm-sans/500.css';
import 'react-toastify/dist/ReactToastify.css'; 

const App = () => {
  return (
    <Box>
      <RouterProvider router={router} />
      <ToastContainer />
    </Box>
  );
};

export default App;
